import React, { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import ReactDOM from 'react-dom/client';
import './index.css';
import App2 from './App2';
import Auth from './auth';
import Loginusername from './auth/loginusername';
import Login_google from './auth/login_google';
import Login_telegram from './auth/login_telegram';
import Account_orders from './order/account/home.jsx';
import Mmo_check_home from './order/p2p_mmo/home.jsx';
import Category from './community/content/category';
import CategoryOld from './community/content/category_old';
import Cheotiktok from './kiemtien/sub4sub/cheotiktok';
import Converttiktok from './kiemtien/socialmedia/convert';
// import Cheotwitter from './kiemtien/sub4sub/cheotwitter';
import Mode_google_maps from './kiemtien/urlshorten/urlshorten_mode/mode_traffix/mode_google_maps';
import Mode_image_check from './kiemtien/urlshorten/urlshorten_mode/mode_traffix/mode_image_check';
import Sub4sub_api_docs from './kiemtien/sub4sub/api_docs.jsx';
import Ordergoogle from './kiemtien/socialmedia/google/order';
import Orders_home_vip from './order/orders/home_vip.jsx';
import Jopcheoweb from './kiemtien/socialmedia/google/cheoweb';
import Cheotele from './kiemtien/socialmedia/telegram/cheo_tele.jsx';
import Checkcodelink from './kiemtien/urlshorten/vuotlink/client/checkcode'
import Jopsearch from './kiemtien/socialmedia/google/search';
import Baohiem from './shop/profiles/signup';
import Content_block from './community/content/block.jsx';
// import Scam_orders from './shop/check/orders';
import Scam_main from './shop/scams_check/main';
import Editshop from './shop/profiles/Editshop';
import Bill from './wallet/bill';
import Radio_files from './radio_signal/files/home.jsx';
import Radio_streams from './radio_signal/streams/home.jsx';
import Radio_devices from './radio_signal/devices/home.jsx';
import Chuyenxu from './wallet/transfer_coins.jsx';
// import Homewallet from './wallet/home.jsx';
import Transaction from './wallet/transaction.jsx';
import Momoidcode from './wallet/Momoidcode.jsx';
import PostOne from './community/content/post_one.jsx';
// import Menu from './community/menu.jsx';
import Cheoinsta_home from './kiemtien/socialmedia/vipig/home.jsx';
import Cheottc_home from './kiemtien/socialmedia/ttc/home.jsx';
import Listcauhinh_fbtik from './kiemtien/socialmedia/ttc/listcauhinh.jsx';
import Listcauhinh_tiktok from './kiemtien/socialmedia/ttc/list_tik.jsx';
import Woker_jop_home from './kiemtien/socialmedia/vipig/woker_jop.jsx';
import Themcauhinh_ig from './kiemtien/socialmedia/vipig/themcauhinh.jsx';
import Listcauhinh_ig from './kiemtien/socialmedia/vipig/listcauhinh.jsx';
import Instruction from './community/instruction.jsx';
import Community from './community/community.jsx';
import Logout from './community/logout.jsx';
import Memory_media from './community/admin/memory_media.jsx';
import Admin_json from './community/admin/admin_json.jsx';
import Themsdt from './community/themsdt.jsx';
import Profile_main from './community/profile/profile_main.jsx';
import Phone_sms from './order/otp_sms/home.jsx';
import Biolink from './community/biolink.jsx';
import Gioithieuzalo from './community/gioithieuzalo.jsx';
import Document from './community/document.jsx';
import Document_coin from './community/document_coin.jsx';
import Blog_posts from './community/content/Blog_posts.jsx';
import Switchlive from './radio_signal/Switchlive.jsx';
import Addusers from './kiemtien/mission/Addusers.jsx';
import Tool from './kiemtien/socialmedia/tool.jsx';
// import Add_user_tool from './kiemtien/socialmedia/add_user.jsx';
import Selectgoogle from './auth/selectgoogle.jsx';
import Infotask from './kiemtien/mission/infotask.jsx';
import Offerwall from './kiemtien/mission/offerwall.jsx';
import Homehust from './shop/mainpage/main_page.jsx';
import Channel from './community/channel.jsx';
import History from './community/history.jsx';
// import Cheoyt from './kiemtien/sub4sub/cheoyt';
import Ai_home from './shop/ai/home';
import Nhatkylink from './nhatkylink';
import Historybuylink from './kiemtien/urlshorten/historybuylink';
import Urlshorten_home from './kiemtien/urlshorten/urlshorten_system/index.jsx';
import Urlshorten_users_home from './kiemtien/urlshorten/urlshorten_users/home.jsx';
import Buyer_add from './wallet/e_commerce/buyer_add.jsx';
import Coin_Home from './wallet/e_commerce/coin_home.jsx';
import Reload_page from './kiemtien/urlshorten/urlshorten_logic/reload_page.jsx';
import Scheduler from './radio_signal/scheduler';
import Webrct from './radio_signal/webrct';
// import Viewer from './radio_signal/livestream/viewer.jsx';
import Liveaudio from './radio_signal/Liveaudio';
import Edit_users from './radio_signal/admin/Edit_users';
// import Livestream from './radio_signal/livestream';
import Texttovoice from './radio_signal/texttovoice';
// import Texttovoice_v2 from './radio_signal/texttovoice_v2';
import Texttovoicehistory from './radio_signal/history';
import Voicetotext from './radio_signal/voicetotext';
import Truyenchu from './giaitri/truyen-chu/Truyenchu';
import Theloaitruyenchu from './giaitri/truyen-chu/the-loai';
import Hometruyenchu from './giaitri/truyen-chu/home';
import Profiletruyenchu from './giaitri/truyen-chu/Profiletruyen';
import Recordaudio from './radio_signal/recordaudio';
import Them20giay from './radio_signal/files/them20giay';
import Nhanxuttc from './kiemtien/socialmedia/ttc/nhanxu.jsx';
import Missonapp from './kiemtien/mission/app.jsx';
import Donate from './wallet/nganhang.jsx';
import Paybank from './wallet/pay/bank.jsx';
import Wallet_savings from './wallet/savings/home.jsx';
import Donate_home from './wallet/donate.jsx';
// import Editcategory from './shop/products/Editcategory';
import Buyaccount from './shop/products/Buyaccount';
import Listaccount from './shop/products/listaccount';
import Adsprofiles from './shop/ads/Adsprofiles';
import Adshistory from './shop/ads/history';
import SellerProfiles from './shop/profiles/Sellerprofiles';
import Products from './shop/products/store';
import Description from './shop/profiles/Description';
import Truyentranh from './giaitri/truyen-tranh/truyen-tranh';
import Truyentranh_v3 from './giaitri/truyen_tranh_v3/truyen-tranh';
import Searchcomics from './giaitri/truyen-tranh/searchcomics';
import Searchcomics_v3 from './giaitri/truyen_tranh_v3/searchcomics';
import Home_truyen_tranh_v2 from './giaitri/truyen_tranh_v2/home';
// import Search_comics_v2 from './giaitri/truyen_tranh_v2/searchcomics';
import The_loai_v2 from './giaitri/truyen_tranh_v2/the-loai';
import Profile_v2 from './giaitri/truyen_tranh_v2/profiletruyen';
// import Truyen_tranh_2 from './giaitri/truyen_tranh_v2/truyen-tranh';
import Truyen_tranh_category_v3 from './giaitri/truyen_tranh_v3/the-loai';
// import Theloaiphim from './giaitri/xem-phim/the-loai';
// import Xemphimchinh from './giaitri/xem-phim/xem-phim';
import Historycomics_v3 from './giaitri/truyen_tranh_v3/historycomics';
// import Truyentranhhome from './giaitri/truyen-tranh/home';
import Truyen_tranh_home_v3 from './giaitri/truyen_tranh_v3/home';
import Nhatkyorders from './nhatkyorders';
// import Play from './giaitri/anime/Play';
import Category_test from './giaitri/visual/category_test.jsx';
import Play_test from './giaitri/visual/play_test.jsx';
import Play_home from './giaitri/visual/home.jsx';
import Profiletruyen from './giaitri/truyen-tranh/profiletruyen';
import Profiletruyen_v3 from './giaitri/truyen_tranh_v3/profiletruyen';
import Editprofile from './shop/profiles/Editprofile';
// import Xemphimhome from './giaitri/xem-phim/home';
import Routerok from './routerok.jsx';
import ReferralPage from './kiemtien/referral/home.jsx';
import Rutgonlink from './kiemtien/urlshorten/rutgonlink.jsx';
import Faucettraffic from './kiemtien/urlshorten/vuotlink/client/home_list.jsx';
import Doithe from './order/Doithe';
import Videos_maker from './kiemtien/socialmedia/videos_maker/home.jsx';
import Auto_tools from './kiemtien/auto_tools/home.jsx';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from 'js-cookie';
import Taiapp from "./community/taiapp";
import Aboutus from "./community/aboutus";
import Private_policy from "./community/private_policy";
import Disclaimer from "./community/disclaimer";
import Plan from "./community/plan";
import Singup from './auth/singup';
import Homeauth from './auth/home';
import Login_home from './auth/login_home_main.jsx';
import Ordergooglemaps from './order/googlemaps';
import Buycards from './order/buy_phonecard';
import Costsocial from './order/Costsocial';
// import Routertest from './routertest' ;Setcookie
import Setcookie from './kiemtien/urlshorten/setcookie.jsx';
import Urlshorten_start from './kiemtien/urlshorten/urlshorten_system/start.jsx';
import Vuotlink from './kiemtien/urlshorten/vuotlink.jsx';
import Vuotlink2 from './kiemtien/urlshorten/Vuotlink2.jsx'
// import reportWebVitals from './reportWebVitals';
import ErrorPage from "./error-page";
import Thuongmai from "./shop/mainpage/danhmuc.jsx";
import Shophome from "./shop/mainpage/home.jsx";
import Shop_vip_max from "./shop/mainpage/vip_max.jsx";
import Admin_home from "./community/admin/home.jsx";
import Orders_home from "./community/admin/orders.jsx";
import Admin_member from "./community/admin/member.jsx";
import Admin_donate from "./community/admin/donate.jsx";
import Admin_deposit from "./community/admin/deposit.jsx";
import Admin_videos_maker from "./community/admin/videos_maker.jsx";
import Admin_views_links from "./community/admin/views_links.jsx";
import Admin_videos_check from "./community/admin/videos_check.jsx";
import Admin_review_app from "./community/admin/review_app.jsx";
import Admin_referrals from "./community/admin/referrals.jsx";
import Admin_money_list from "./community/admin/money_list.jsx";
import Admin_server_port from "./community/admin/server_port.jsx";
import Test_websocket from "./community/process/mqtt/test.jsx";
import Convert_national_market from "./community/process/national_market.jsx";

import Jop from "./kiemtien/sub4sub/jop.jsx";
import store from './js/store.js'; // Import Redux store
import { Provider } from 'react-redux';
import {
  // Link ,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const hideLoadingMessage = () => {
  const loadingMessage = document.getElementById('loading-message');
  if (loadingMessage) {
    loadingMessage.style.display = 'none';
  }
};

document.addEventListener('DOMContentLoaded', hideLoadingMessage); // or use 'load' event

// const Sorumaidcafe = React.lazy(() => import('./community/sorumaid/bio.jsx'));



const router = createBrowserRouter([
  {
    path: "",
    errorElement: <ErrorPage />,
    children: [
      // {
      //   path: "sorumaidcafe",
      //   element: (
      //     <Suspense fallback={<div>Loading...</div>}>
      //       <Sorumaidcafe />
      //     </Suspense>
      //   ),
      // },
      {
        path: "",
        element: < Routerok />,
        children: [
          {
            path: "",
            element: < Homehust />,
          },
          {
            path: "/home2/",
            children: [
              {
                path: "",
                element: < Urlshorten_home />,
              },
            ]
          },
          {
            path: "/home/",
            children: [
              {
                path: "",
                element: < Vuotlink />,
              },
            ]
          },
          // {

          //   path: "the-loai",
          //   children: [
          //     {
          //       path: ":slug_2",
          //       element: <Truyen_tranh_category_v3 />,
          //     },
          //   ],

          // },
          // {
          //   path: "truyen-hay",
          //   children: [
          //     {
          //       path: "home",
          //       element: <Truyen_tranh_home_v3 />,
          //     },
          //   ],
          // },
          {

            path: "truyen-chu",
            children: [
              {
                path: ":slug_2",
                element: <Truyenchu />,
              },
              {
                path: "/truyen-chu/home",
                element: <Hometruyenchu />,
              },
              {
                path: "/truyen-chu/:slug_2/:chapter",
                element: <Truyenchu />,
              },
              {
                path: "/truyen-chu/profile/:slug_2",
                element: <Profiletruyenchu />,
              },
              {
                path: "/truyen-chu/the-loai/:slug_2",
                element: <Theloaitruyenchu />,
              },
              {
                path: "/truyen-chu/the-loai/:slug_2/:chapter",
                element: <Theloaitruyenchu />,
              },
            ],

          },
          // {
          //   path: "/film/",
          //   children: [
          //     {
          //       path: "play",
          //       children: [
          //         {
          //           path: ":slug_2",
          //           element: < Xemphimchinh />,
          //         }]
          //     },
          //     {
          //       path: "home",
          //       element: <Xemphimhome />,
          //     },
          //     {
          //       path: "the-loai",
          //       children: [
          //         {
          //           path: ":slug_2",
          //           element: < Theloaiphim />,
          //         }
          //       ]
          //     },
          //   ]
          // },
          // {
          //   path: "truyen-tranh",
          //   children: [
          //     {
          //       path: "home",
          //       element: <Home_truyen_tranh_v2 />,
          //     },
          //     {
          //       path: "category",
          //       children: [
          //         {
          //           path: ":slug_2",
          //           element: <The_loai_v2 />,
          //         },]
          //     },
          //     {
          //       path: "profile",
          //       children: [
          //         {
          //           path: ":slug_2",
          //           element: <Profile_v2 />,
          //         },]
          //     },
          //     {
          //       path: "search",
          //       element: <Searchcomics_v3 />,
          //     },
          //     {
          //       path: "search",
          //       element: <Searchcomics />,
          //     },
          //     {
          //       path: "historycomics",
          //       element: <Historycomics_v3 />,
          //     },
          //     // {
          //     //   path: ":slug_1",
          //     //   children: [
          //     //     {
          //     //       path: ":slug_2",
          //     //       element: <Truyen_tranh_2 />,
          //     //     },]
          //     // },
          //     {
          //       path: ":slug_2",
          //       element: <Truyentranh_v3 />,
          //     },


          //   ],

          // },
          {

            path: "/home2/",
            children: [
              {
                path: "",
                element: < Vuotlink2 />,
              },
            ]
          },
          {
            path: '/ai/',
            element: <Ai_home />,
            children: [
              {
                path: ":slug_1",
                children: [
                  {
                    path: ":slug_2",
                    children: [
                      {
                        path: ":slug_3"
                      }
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: '/shop/',
            children: [
              {
                path: 'auto_tools',
                children: [
                  {
                    path: ':slug_1',
                    element: <Auto_tools />,
                  }
                ],
              },
              {
                path: "savings",
                children: [
                  {
                    path: ":slug_1",
                    element: < Wallet_savings />,
                    children: [
                      {
                        path: ":slug_2"
                      }
                    ]
                  }
                ]
              },
              {
                path: "radio",
                children: [
                  {
                    path: "files",
                    element: <Radio_files />,
                    children: [
                      {
                        path: ":slug_2",
                        children: [
                          {
                            path: ":slug_3",
                          },
                        ]
                      }
                    ]
                  },
                  {
                    path: "streams",
                    element: <Radio_streams />,
                    children: [
                      {
                        path: ":slug_2",
                        children: [
                          {
                            path: ":slug_3",
                          },
                        ]
                      }
                    ]
                  },
                  {
                    path: "devices",
                    element: <Radio_devices />,
                    children: [
                      {
                        path: ":slug_2",
                        children: [
                          {
                            path: ":slug_3",
                          },
                        ]
                      }
                    ]
                  },
                  {
                    path: "admin",
                    element: <Edit_users />,
                    children: [
                      {
                        path: ":slug_2",
                      }
                    ]
                  }
                ]
              },
              {
                path: "thuongmai/:id",
                element: <Thuongmai />,
              },
              {
                path: "main",
                element: <Shop_vip_max />,
                children: [
                  {
                    path: ":slug_2"
                  }
                ],
              },
              {
                path: "check",
                element: <Scam_main />,
                children: [
                  {
                    path: ':slug_1',
                    children: [
                      {
                        path: ":slug_2",
                        children: [
                          {
                            path: ":slug_3"
                          }]
                      }
                    ]
                  }
                ],
              },
              {
                path: "cv_soru",
                element: < Document />,
              },
              {
                path: "document_coin",
                element: < Document_coin />,
              },
              {
                path: "phone/sms",
                children: [
                  {
                    path: ':slug_2',
                    element: <Phone_sms />,
                  }
                ],
              },
              {
                path: "profiles",
                children: [
                  {
                    path: 'block',
                    element: <Content_block />
                  },
                  {
                    path: ":slug_1",
                    children: [
                      {
                        path: ":slug_2",
                      },
                    ],
                    element: <Profile_main />,
                  }
                ],
              },
              {
                path: 'e-commerce',
                children: [
                  {
                    path: 'buyer_add',
                    element: <Buyer_add />
                  },
                  {
                    path: ":slug_1",
                    children: [
                      {
                        path: ":slug_2",
                      },
                    ],
                    element: <Coin_Home />
                  }
                ],
              },
              {
                path: 'creative',
                element: <Urlshorten_users_home />,
                children: [
                  { path: ":slug_2" },
                ],
              },
              {
                path: 'order',
                children: [
                  {
                    path: 'googlemaps',
                    element: <Ordergooglemaps />,
                  },
                ],
              },
              {
                path: 'mission',
                element: <Missonapp />,
                children: [
                  { path: ":slug_2" },
                ],
              },
              {
                path: 'posts',
                element: <PostOne />,
                children: [
                  { path: ":slug_2" },
                ],
              },
              {
                path: 'category/tips_vip_old',
                element: <CategoryOld />,
              },
              {
                path: 'category/:slug_2',
                element: <Category />,
              },
              {
                path: 'home',
                element: <Shophome />,
                children: [
                  { path: ":slug_2" },
                ],
              },
              {
                path: 'home2',
                element: <Homehust />,
                children: [
                  { path: ":slug_2" },
                ],
              },
              {
                path: "auth",
                children: [
                  {
                    path: 'login_home',
                    element: <Login_home />,
                  },
                  {
                    path: 'home',
                    element: <Homeauth />,
                  },
                  {
                    path: 'loginusername',
                    element: <Loginusername action="login" />,
                  },
                  {
                    path: 'login_google',
                    element: <Login_google />,
                  },
                  {
                    path: 'signupusername',
                    element: <Loginusername action="signup" />,
                  },
                ],
              },
              // {
              //   path: 'viewer',
              //   element: <Viewer />,
              //   children: [
              //     { path: ":slug_2" },
              //   ],
              // },
              {
                path: 'biolink',
                element: <Biolink />,
                children: [
                  { path: ":slug_2" },
                ],
              },
              {
                path: 'history',
                element: <History />,
                children: [{
                  path: ":slug_2"
                },]
              },
              {
                path: 'community',
                element: <Community />,
              },
              {
                path: 'tasks',
                element: <Faucettraffic />,
                children: [
                  { path: ":slug_2" },
                ],
              },
              {
                path: 'jopweb',
                element: <Jopcheoweb />,
              },
              {
                path: "referrals",
                element: <ReferralPage />,
                children: [
                  {
                    path: ":slug_1",
                    children: [
                      {
                        path: ":slug_2",
                      },
                    ],
                  },
                ],
              },
              {
                path: 'proweb',
                element: <Jopsearch />,
              },
              {
                path: 'accounts',
                children: [
                  {
                    path: ':slug_1',
                    element: <Account_orders />,
                    children: [
                      {
                        path: ':slug_2',
                        children: [
                          {
                            path: ':slug_3',
                            children: [
                              {
                                path: ':slug_4'  // 👈 thêm level 4
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                path: 'p2p',
                children: [
                  {
                    path: ':slug_1',
                    element: <Mmo_check_home />,
                    children: [
                      {
                        path: ':slug_2',
                        element: <Mmo_check_home />,
                        children: [
                          {
                            path: ':slug_3',
                            element: <Mmo_check_home />,
                            children: [
                              {
                                path: ':slug_4',  // 👈 thêm level 4
                                element: <Mmo_check_home />
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                path: 'cheoweb',
                element: <Jopcheoweb />,
              },
              {
                path: 'editcategory',
                element: <Editprofile />,
                children: [
                  { path: 'post' }
                  , {
                    path: 'buyaccount',
                    element: <Buyaccount />,
                  },
                ],
              },
              {
                path: "channel",
                element: < Channel />,
              },
              {
                path: "orderapp",
                element: < Ordergoogle />,
              },
              {
                path: "orders",
                children: [
                  {
                    path: ":slug_2",
                    element: <Orders_home_vip />,
                    children: [
                      {
                        path: ":slug_3"
                      }]
                  }]
              },
              {
                path: "rate",
                element: < Costsocial />,
              },
              {
                path: "account/:id",
                element: <Listaccount />
              },
              {
                path: "editshop",
                element: < Editshop />,
              },
              {
                path: "transfer_coins",
                element: < Chuyenxu />,
              },
              {
                path: "transaction",
                element: < Transaction />,
              },
              {
                path: "plan",
                element: < Plan />,
              },
              {
                path: "momoidcode",
                element: < Momoidcode />,
              },
              {
                path: "content",
                children: [
                  {
                    path: "blog_posts",
                    element: < Blog_posts mode={'telegram'} />,
                    children: [
                      {
                        path: ":slug_1",
                        children: [
                          {
                            path: ":slug_2",
                          }]
                      }]
                  }]
              },
              {
                path: "donate",
                element: < Donate />,
                children: [
                  {
                    path: ":slug_2",
                    children: [
                      {
                        path: ":id_cash"
                      }]
                  }]
              },
              {
                path: "donate",
                element: < Donate />,
                children: [
                  {
                    path: ":slug_2"
                  }]
              },
              {
                path: 'jop/cheotele',
                element: <Cheotele />,
              },
              {
                path: "jop/",

                element: <Jop />,
                children: [
                  {
                    path: "tiktok/api_docs",
                    element: <Sub4sub_api_docs category="sub4sub_tiktok" />,
                  },
                  {
                    path: "cheotiktok",
                    element: <Cheotiktok />,
                  },
                  {
                    path: "googlemaps",
                    element: <Mode_google_maps />,
                  },
                  // {
                  //   path: "cheotwitter",
                  //   element: <Cheotwitter />,
                  // },
                  // {
                  //   path: "cheoyt",
                  //   element: <Cheoyt />,
                  // },
                ],
              },
              {
                path: "bill",
                element: < Bill />,
                children: [
                  {
                    path: ":slug_2",
                    element: <Bill />,
                  }]
              },
              {
                path: "wallet",
                children: [
                  {
                    path: "paybank",
                    element: <Paybank />,
                  },
                  {
                    path: "donate",
                    element: <Donate_home />,
                  },
                  // {
                  //   path: "home",
                  //   element: <Homewallet />,
                  // },
                  {
                    path: "buycard",
                    element: <Buycards />,
                  },
                  {
                    path: ":slug_2",
                    element: <Paybank />,
                  },

                ]
              },
              {
                path: "ads",
                element: <Editprofile />,
                children: [
                  { path: '', element: <Description /> },
                  {
                    path: 'adsprofiles',
                    element: <Adsprofiles />,
                    children: [
                      {
                        path: ":slug_2",
                      },
                    ]
                  },
                  {
                    path: 'history',
                    element: <Adshistory />,
                    children: [
                      {
                        path: ''
                      }]
                  },
                ],
              },
              {
                path: "doithe",
                children: [
                  { path: '', element: <Doithe /> },
                  {
                    path: ":slug_2",
                    element: < Doithe />,
                  },
                  {
                    path: "pay_home",
                    element: < Doithe />,
                  },
                  {
                    path: "pay_edit",
                    element: < Doithe />,
                  },
                  {
                    path: "history",
                    element: < Doithe />,
                  },
                ],
              },


              {
                path: 'editprofile',
                element: <Editprofile />,
                children: [
                  { path: '', element: <Description /> },
                  {
                    path: 'products',
                    element: <Products />,
                  },
                ],
              },
              {
                path: 'profile',
                element: <SellerProfiles />,
                children: [
                  {
                    path: ":slug_2",
                    element: <Description />,
                  },
                  { index: true, path: '', element: <Description /> },
                  {
                    path: 'products',
                    element: <Products />,
                  },
                ],
              },
            ],
          },
          {
            path: "/profile/",
            children: [
              {
                path: "auth",
                element: < Auth />,
              },
              // {
              //   path: "truyen-tranh",
              //   children: [{
              //     path: ":slug_2",
              //     element: <Profiletruyen_v3 />,
              //   },]
              // },
              // {
              //   path: "truyen",
              //   children: [{
              //     path: ":slug_2",
              //     element: <Profiletruyen_v3 />,
              //   },]
              // }
            ]
          },
          {
            path: "/reactapp/",
            children: [
              {
                path: "convert_national_market",
                element: < Convert_national_market />,
              },
              {
                path: "test_websocket",
                element: < Test_websocket />,
              },
              {
                path: "log_out",
                element: <Logout />,
              },
              {
                path: "auth",
                element: < Auth />,
              },
              {
                path: 'videos_maker',
                children: [
                  {
                    path: ':slug_1',
                    element: <Videos_maker />,
                    children: [
                      {
                        path: ":slug_2"
                      }
                    ]
                  }
                ],
              },
              {
                path: "log_out",
                element: <Logout />,
              },
              {
                path: "test_json",
                element: <Admin_json />,
              },
              {
                path: "testmaps",
                element: < Mode_google_maps />,
              },
              {
                path: "testzalo",
                element: < Mode_image_check />,
              },
              ,
              {
                path: 'insta',
                children: [
                  {
                    path: "home",
                    element: < Cheoinsta_home />,
                  },
                  {
                    path: "themcauhinh",
                    element: < Themcauhinh_ig />,
                  },
                  {
                    path: "listcauhinh",
                    element: < Listcauhinh_ig />,
                  }]
              },
              {
                path: 'sunflower',
                children: [
                  {
                    path: "themcauhinh",
                    element: < Themcauhinh_ig />,
                  },
                  {
                    path: "listcauhinh",
                    element: < Listcauhinh_fbtik />,
                  },
                  {
                    path: ":slug_1",
                    children: [
                      {
                        path: "home",
                        element: < Cheottc_home />,
                      },
                      {
                        path: "listcauhinh",
                        element: < Listcauhinh_tiktok />,
                      },
                      {
                        path: ":slug_2",
                        element: <Woker_jop_home />,
                      }
                    ]
                  }]
              },
              {
                path: "reload_page",
                element: < Reload_page />,
              },
              {
                path: "menu",
                element: < Shop_vip_max />,
              },
              {
                path: "selectgoogle",
                element: < Selectgoogle />,
              },
              {
                path: "aboutus",
                element: < Aboutus />,
              },
              {
                path: "private_policy",
                element: < Private_policy />,
              },
              {
                path: "disclaimer",
                element: < Disclaimer />,
              },
              {
                path: "auth",
                children: [
                  {
                    path: 'loginusername',
                    element: <Loginusername action="login" />,
                  },
                  {
                    path: 'signupusername',
                    element: <Loginusername action="signup" />,
                  },
                  {
                    path: 'telegram',
                    element: <Login_telegram />,
                  },
                ],
              },
              {
                path: "gioithieuzalo",
                element: < Gioithieuzalo />,
              },
              {
                path: "themsdt",
                element: < Themsdt />,
              },
              {
                path: 'checkcode',
                element: <Checkcodelink />,
              },
              {
                path: "cv_soru",
                element: < Document />,
              },
              {
                path: "document",
                element: < Document />,
              },
              {
                path: "switchlive",
                element: < Switchlive />,
              },
              {
                path: "addusers",
                element: < Addusers />,
              },
              {
                path: "auto",
                element: <  Tool />,
                children: [
                  {
                    path: ":slug_2",
                    element: <Adshistory />,

                  }
                ]
              },
              {
                path: "infotask",
                element: < Infotask />,
                children: [{
                  path: ":slug_2",
                },]
              },
              {
                path: "instruction",
                element: < Instruction />,
              },
              {
                path: "offerwall",
                element: < Offerwall />,
                children: [{
                  path: ":slug_2"
                },]
              },

              {
                path: "exchangepoints",
                element: < Nhanxuttc />,
                children: [{
                  path: ":slug_2",
                },]
              },
              {
                path: "",
                element: < Homehust />,
              },
              {
                path: "texttovoicehistory",
                element: < Texttovoicehistory />,
              },
              {
                path: "texttovoice",
                element: < Texttovoice />,
                children: [
                  {
                    path: ":slug_2",
                  }
                ]
              },
              {
                path: "voicetotext",
                element: < Voicetotext />,
                children: [
                  {
                    path: ":slug_2",
                  }
                ]
              },
              {
                path: "liveaudio",
                children: [
                  {
                    path: ":slug_2",
                    element: < Liveaudio />
                  }
                ]
              },
              {
                path: "admin",
                children: [
                  {
                    path: ":slug_2",
                    element: < Liveaudio />
                  }
                ]
              },
              // {
              //   path: "livestream",
              //   element: < Livestream />,
              //   children: [
              //     {
              //       path: ":slug_2",
              //     }
              //   ]
              // },
              {
                path: "cron",
                element: < Scheduler />
              },
              {
                path: "webrct",
                element: < Webrct />
              },
              {
                path: "recordaudio",
                children: [
                  {
                    path: ":slug_2",
                    element: < Recordaudio />
                  }
                ]
              },
              {
                path: "them20giay",
                children: [
                  {
                    path: ":slug_2",
                    element: < Them20giay />
                  }
                ]
              },
              {
                path: "singup",
                element: < Singup />,
              },
              // {
              //   path: "switchlive",
              //   element: < Switchlive />,
              // },
              {
                path: "baohiem",
                element: < Baohiem />,
              },
              {
                path: "hello/:id",
                element: <App2 />,
              },
              {
                path: "vuotlink",
                element: <Setcookie />,
              },
              {
                path: "hustmediavippro",
                element: <Urlshorten_start />,
              },
              {
                path: "thankiu",
                element: <Taiapp />,
              },
              {
                path: "nhatkyorders",
                element: <Nhatkyorders />,
              },
              {
                path: "nhatkylink",
                element: <Nhatkylink />,
              },
              {
                path: "historybuylink",
                element: <Historybuylink />,
              },
              {
                path: "nhatkyaccount",
                element: <Nhatkyorders />,
              },
              {
                path: "accounts_history",
                element: <Nhatkyorders />,
              },
              {
                path: "cash_diary",
                element: <Nhatkyorders />,
              },
              {
                path: "checkvar",
                element: <Nhatkyorders />,
              },
              // {
              //   path: 'xem-phim/:filmId',
              //   element: <Play />,
              // },
              {
                path: 'visual/category_test/:slug_2',
                element: <Category_test />,
              },
              {
                path: 'visual/:filmId',
                element: <Play_test />,
              },
              {
                path: 'visual/home',
                element: <Play_home />,
              },
              {
                path: "rutgonlink",
                element: <Rutgonlink />,
              },
              {
                path: "profile",
                children: [
                  {
                    path: ":slug_2",
                    element: <Profile_main />,
                  },
                ],
              },
              {
                path: "truyen-tranh",
                children: [
                  {
                    path: ":slug_2",
                    element: <Truyentranh />,
                  },
                ],
              },
              {
                path: "converttiktok",
                element: <Converttiktok />,
              },
              {
                path: "jop/",

                element: <Jop />,
                children: [
                  {
                    path: "tiktok/api_docs",
                    element: <Sub4sub_api_docs category="sub4sub_tiktok" />,
                  },
                  {
                    path: 'cheotele',
                    element: <Cheotele />,
                  },
                  {
                    path: "googlemaps",
                    element: <Mode_google_maps />,
                  },
                  // {
                  //   path: "cheotwitter",
                  //   element: <Cheotwitter />,
                  // },
                  // {
                  //   path: "cheoyt",
                  //   element: <Cheoyt />,
                  // },
                ],
              },

              {
                path: "hustadmin",
                children: [
                  {
                    path: "home",
                    element: <Admin_home />,
                  },
                  {
                    path: "referrals",
                    element: <Admin_referrals />,
                  },
                  {
                    path: "memory",
                    children: [
                      {
                        path: 'home',
                        element: <Admin_home />,
                      },
                      {
                        path: "folder/:slug_2",
                        element: <Memory_media />,
                      }
                    ],
                  },
                  {
                    path: "orders",
                    element: <Orders_home />,
                  },
                  {
                    path: "service_money_list",
                    element: <Admin_money_list />,
                  },
                  {
                    path: "server_port",
                    element: <Admin_server_port />,
                  },
                  {
                    path: "member",
                    element: <Admin_member />,
                  },
                  {
                    path: "worker",
                    element: <Admin_member />,
                  },
                  {
                    path: "donate",
                    element: <Admin_donate />,
                  },
                  {
                    path: "deposit",
                    element: <Admin_deposit />,
                  },
                  {
                    path: "videos_maker",
                    element: <Admin_videos_maker />,
                  },
                  {
                    path: "views_links",
                    element: <Admin_views_links />,
                  },
                  {
                    path: ":slug_2",
                    element: <Profiletruyen />,
                  },
                  {
                    path: "videos_check",
                    element: <Admin_videos_check />,
                  },
                  {
                    path: "review_app",
                    element: <Admin_review_app />,
                  }
                ]
              },
            ],
          },
        ],
      },

    ],
  },

]);


ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <>
        {/* Router chính của bạn */}
        <RouterProvider router={router} />
      </>
    </I18nextProvider>
  </Provider>,
  /* </React.StrictMode> */
);
export { Cookies };
